import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from "vuex-persistedstate";
import auth from './modules/auth'
import user from './modules/user'
import device from './modules/device'
Vue.use(Vuex)
const dataState = createPersistedState({
  paths: ['auth', 'device']
})

export default new Vuex.Store({
    modules: {
        auth,
        user,
        device
    },
    plugins: [dataState]
    
})
